<template>
  <div class="pre-cut-popup">
    <UseSvg
      height="16"
      width="16"
      class="icon icon--svg icon--info-circle-bold"
      icon="info-circle-bold"
    />
    <div class="pre-cut-popup__tooltip">
      <div class="pre-cut-popup__title">🔍 What’s pre-cut?</div>
      <div class="pre-cut-popup__body">
        <p class="pre-cut-popup__description">
          Pre-cut transfers are ready to apply right out of the package—no trimming required!
          <br />
          This ensures a faster, cleaner application every time.
        </p>
        <div class="pre-cut-popup__comparison">
          <div class="pre-cut-popup__comparison-container">
            <div class="pre-cut-popup__comparison-image-container">
              <img
                :src="noPreCutImageUrl"
                alt="No Pre-cut Image"
                class="pre-cut-popup__comparison-image"
              />
            </div>
            <div class="pre-cut-popup__comparison-title">No Pre-cut</div>
            <div class="pre-cut-popup__comparison-description">Time per 10 transfers:</div>
            <div class="pre-cut-popup__comparison-duration">10 minutes</div>
          </div>
          <div class="pre-cut-popup__comparison-container">
            <div class="pre-cut-popup__comparison-image-container">
              <img
                :src="preCutImageUrl"
                alt="No Pre-cut Image"
                class="pre-cut-popup__comparison-image"
              />
            </div>
            <div class="pre-cut-popup__comparison-title">Pre-cut</div>
            <div class="pre-cut-popup__comparison-description">Time per 10 transfers:</div>
            <div
              class="pre-cut-popup__comparison-duration pre-cut-popup__comparison-duration-precut"
            >
              0 minutes
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { remoteImageStaticUrl } from "common/utils/remote-image";
import { PRE_CUT_IMAGE_CONFIG } from "common/pre-cut.constants";
import UseSvg from "components/jiffy/vue-cart/UseSvg.vue";

export default {
  name: "PreCutPopup",
  components: {
    UseSvg
  },
  computed: {
    noPreCutImageUrl() {
      return remoteImageStaticUrl("gen/pre-cut-tooltip/no-pre-cut.jpeg", {
        ...PRE_CUT_IMAGE_CONFIG,
        ixlib: 'rb-0.3.5'
      })
    },
    preCutImageUrl() {
      return remoteImageStaticUrl("gen/pre-cut-tooltip/pre-cut.png", {
        ...PRE_CUT_IMAGE_CONFIG,
        ixlib: 'rb-0.3.5'
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

.pre-cut-popup {
  $this: &;
  position: relative;

  &:hover {
    #{$this}__tooltip {
      transform: translateY(5px);
      visibility: visible;
      opacity: 1;
    }
  }

  &__tooltip {
    display: block;
    width: 320px;
    position: absolute;
    z-index: 1;
    margin-top: 25px;
    margin-left: -260px;
    background-color: $white;
    box-shadow: 0 5px 10px 0 rgba($gray-body, 0.15);
    border: 1px solid $gray-border;
    border-radius: 8px;
    padding: 12px;
    transform: translateY(0);
    visibility: hidden;
    opacity: 0;
    transition: all 300ms ease;
  }

  &__title {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 12px;
  }

  &__description {
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 12px;
  }

  &__comparison {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 12px;
    height: 234px;
  }

  &__comparison-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }

  &__comparison-image-container {
    height: 168px;
    width: 142px;
    margin-bottom: 12px;
  }

  &__comparison-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__comparison-title {
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 9px;
  }

  &__comparison-description {
    font-size: 12px;
  }

  &__comparison-duration {
    font-size: 12px;
    font-weight: 700;
  }

  &__comparison-duration-precut {
    color: $pre-cut-tooltip-green;
  }
}
</style>
